// Zeitsteuerung für das automatische Speichern, ohne React.
//
// schedule()  wartet debounceMs, dann wird gespeichert (falls noch offen).
// Scheitert das Speichern, folgen Wiederholungen nach backoffMs[0],
// backoffMs[1], …; der letzte Wert gilt für alle weiteren Versuche.
// retryNow() speichert sofort (Knopf „Erneut versuchen“, Tab wieder
// sichtbar). Nach einem Erfolg, der noch offene Änderungen hinterlässt
// (während des Requests bearbeitet), wird erneut geplant.

export function createAutoSaver({ save, shouldSave, onFailure, debounceMs = 3000, backoffMs = [10000, 30000, 60000] }) {
  let timer = null;
  let running = false;
  let failures = 0;
  let disposed = false;

  const clear = () => {
    if (timer) clearTimeout(timer);
    timer = null;
  };

  const planIn = (ms) => {
    if (disposed) return;
    clear();
    timer = setTimeout(run, ms);
  };

  async function run() {
    timer = null;
    if (running || disposed) return;
    if (!shouldSave()) {
      // Nothing pending any more (other calc loaded, saved by hand):
      // the failure streak is over, later edits schedule normally.
      failures = 0;
      return;
    }
    running = true;
    try {
      await save();
      failures = 0;
      running = false;
      if (shouldSave()) planIn(debounceMs);
    } catch (err) {
      running = false;
      if (disposed) return;
      failures += 1;
      onFailure?.(err, failures);
      planIn(backoffMs[Math.min(failures - 1, backoffMs.length - 1)]);
    }
  }

  return {
    schedule() {
      // Während einer Fehlerserie läuft bereits der Wiederholungs-Timer.
      if (failures > 0) return;
      planIn(debounceMs);
    },
    retryNow() {
      clear();
      return run();
    },
    cancel() {
      clear();
      failures = 0;
    },
    // Final stop (hook unmount): a save still in flight neither
    // reports nor plans anything after it settles.
    dispose() {
      disposed = true;
      clear();
    },
    get failures() {
      return failures;
    }
  };
}
